import { post } from './HttpClient';
import { API_SEARCH_ONLY_LISTING } from './ApisRoutes';
import store from "../redux";
import { setMetaData, setMetaDataCount } from "../redux/slices/appconfigSlice";
import { toast } from "react-toastify";
import { setLastSearch } from '../redux/slices/loginconfigSlice';

export const GetSearchOnlyHotelsService = params => {
    // console.log(JSON.stringify(params), 'search');

    return new Promise((resolve, reject) => {
        post(API_SEARCH_ONLY_LISTING, params)
            .then(response => {
                // console.log(response?.data?.metaData, '******META DATA*****', response?.data?.offers?.length, ' Offers length');
                store.dispatch(setMetaDataCount(response?.data?.metaData?.offersAfterFilter || 0));
                store.dispatch(setMetaData(response?.data?.metaData));
                if (response?.data?.warnings?.length) {
                    if (
                        response?.data?.warnings[0]?.code !== '204.05' &&
                        response?.data?.warnings[0]?.code !== '204.02' &&
                        response?.data?.warnings[0]?.code !== '204.03'
                    ) {
                        console.log('AppSearch is returning data from here!!');
                        toast.info(response?.data?.warnings[0].description);
                        return resolve(response);
                    }
                }

                const pageddata = response?.data?.offers?.map(hotel => {
                    if (hotel !== undefined) {
                        return {
                            ...hotel?.newPackagedOffer?.hotelOfferSingleRoom,
                            price: {
                                totalPrice: hotel?.price?.packageTotalPrice?.value,
                                currency: hotel?.price?.packageTotalPrice?.currency,
                            },
                            perPersonPrice: {
                                totalPrice: hotel?.price?.averageCostPerPerson?.value,
                                currency: hotel?.price?.averageCostPerPerson?.currency,
                            },
                            address:
                                hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location?.address?.city +
                                ', ' +
                                hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location?.address?.country,
                            media: [
                                {
                                    url: hotel?.newPackagedOffer?.hotelOfferSingleRoom?.thumbnailUrl,
                                },
                            ],
                            objHotel: hotel,
                            guidForBooking: response?.data?.correlationId ? response.data.correlationId : params.GUID,
                        };
                    }
                });

                if (pageddata?.length > 0 && params?.SearchType !== "GPT") {
                    const lastSearchParams = {
                        ...params,
                        date: new Date(),
                        GUID: '',
                        id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
                    };

                    store.dispatch(setLastSearch(lastSearchParams));
                }


                if (response?.data?.responseType === 'RealTime') {
                    return resolve({
                        correlation_Id: response.data.correlationId,
                        hotelsArray: pageddata,
                    });
                } else {
                    return resolve({
                        correlationId: response?.data?.correlationId ? response.data.correlationId : params.GUID,
                        hotelsArray: pageddata,
                        response,
                    });
                }
            })
            .catch(error => {
                console.log(error, 'status');
                reject(error);
            });
    });
};

// export const GetSearchOnlyForHotel = params => {
//   // console.log({params}, 'search');
//
//   return new Promise((resolve, reject) => {
//     post(API_SEARCH_ONLY_LISTING, params)
//       .then(response => {
//         // console.log({response}, 'SearchOnlyListing');
//
//         let _hotel = response?.data?.offers?.map(hotel => {
//           if (hotel !== undefined) {
//             return {
//               ...hotel?.newPackagedOffer?.hotelOfferSingleRoom,
//               price: {
//                 totalPrice: hotel?.price?.packageTotalPrice?.value,
//                 currency: hotel?.price?.packageTotalPrice?.currency,
//               },
//               perPersonPrice: {
//                 totalPrice: hotel?.price?.averageCostPerPerson?.value,
//                 currency: hotel?.price?.averageCostPerPerson?.currency,
//               },
//               address: hotel?.newPackagedOffer?.hotelOfferSingleRoom.location.address.address1,
//               media: [
//                 {
//                   url: hotel?.newPackagedOffer?.hotelOfferSingleRoom?.thumbnailUrl,
//                 },
//               ],
//               objHotel: hotel,
//               guidForBooking: response?.data?.correlationId,
//             };
//           }
//         });
//
//         return resolve({
//           correlationId: response?.data?.correlationId,
//           hotelsArray: _hotel,
//           response,
//         });
//       })
//       .catch(error => {
//         console.log(error, 'status');
//         reject(error);
//       });
//   });
// };

// export const GetWaitingScreenDataService = params => {
//   return new Promise((resolve, reject) => {
//     get(`${API_GET_WAITING_SCREEN_DATA}?${params}`)
//       .then(response => {
//         return resolve(response);
//       })
//       .catch(error => {
//         console.log(error, 'status');
//         reject(error);
//       });
//   });
// };

// export const getMetaDataOnlyForHotelService = params => {
//   console.log(params, 'search');
//
//   return new Promise((resolve, reject) => {
//     post(API_SEARCH_ONLY_LISTING, params)
//       .then(response => {
//         return resolve(response);
//       })
//       .catch(error => {
//         console.log(error, 'status');
//         reject(error);
//       });
//   });
// };
